module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premier_mobile-b38a23cb6add1e724db67643b0cea7d3.jpg";